import { Link } from "react-router-dom";
import { ShieldCheck, Users, Radio, Film, Star, Music2, Settings2, Activity } from "lucide-react";

const CARDS = [
  { label: "Review Creators", desc: "Approve or restrict creator applications", href: "/admin/creators", icon: Users, color: "green" },
  { label: "Manage Stations", desc: "Approve, restrict, or review radio stations", href: "/admin/stations", icon: Radio, color: "purple" },
  { label: "Review Shows", desc: "Approve or reject creator radio shows", href: "/admin/shows", icon: Music2, color: "green" },
  { label: "Review Content", desc: "Approve or reject uploaded content", href: "/admin/content", icon: Film, color: "purple" },
  { label: "Featured Content", desc: "Manage homepage premiere and featured slots", href: "/admin/featured", icon: Star, color: "green" },
  { label: "Site Settings", desc: "Station of the Month, featured stations, platform banner", href: "/admin/settings", icon: Settings2, color: "purple" },
  { label: "Monitoring", desc: "Audio conversion stats, system health", href: "/admin/monitoring", icon: Activity, color: "green" },
];

export default function Admin() {
  return (
    <div data-testid="admin-dashboard" className="space-y-6">
      <div className="flex items-center gap-3 mb-2">
        <ShieldCheck size={22} className="text-[#B026FF]" />
        <div>
          <h1 className="text-2xl font-black text-white">Admin Panel</h1>
          <p className="text-zinc-500 text-sm">Manage the StagePass platform</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {CARDS.map(({ label, desc, href, icon: Icon, color }) => (
          <Link key={href} to={href} data-testid={`admin-card-${label.toLowerCase().replace(/\s+/g, "-")}`}
            className={`bg-[#111] border border-white/5 rounded-2xl p-5 hover:bg-[#1a1a1a] transition-all ${
              color === "green" ? "hover:border-[#00ff77]/30" : "hover:border-[#B026FF]/30"
            }`}>
            <Icon size={20} className={color === "green" ? "text-[#00ff77] mb-3" : "text-[#B026FF] mb-3"} />
            <h3 className="text-white font-bold text-sm mb-1">{label}</h3>
            <p className="text-zinc-500 text-xs">{desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
